module.exports = __webpack_public_path__ + "static/media/2-light-haze-blue-compressed.aa6a3cb4.png";